<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import { useGameStore } from '@/stores/gameStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore();

const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="gameStore.cdnUrl + 'images/map/blackhole_orange.webp'"
    :toast-text="t('news.types.shipsLostBlackHole.toast', { count: props.newsItem.contentData.ships })"
  >
    <NewsItemBaseStructure
      :newsItem="props.newsItem"
      :item-image="gameStore.cdnUrl + 'images/map/blackhole_orange.webp'"
      :header="t('news.types.shipsLostBlackHole.title')"
    >
      <template #image>
        <div class="blackhole-image">
          <img :src="gameStore.cdnUrl + 'images/map/blackhole_orange.webp'" class="w-full h-full object-cover" :alt="t('news.types.shipsLostBlackHole.title')"/>
          <div class="black-circle"></div>
        </div>
      </template>
      {{ t('news.types.shipsLostBlackHole.body', { count: props.newsItem.contentData.ships }) }}<br>
    </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss">
.blackhole-image {
  position: relative;
  width: 8rem;
  height: 8rem;
  border-radius: 0.375rem;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow:
    0 2px 6px rgba(0, 0, 0, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
}

.black-circle {
  position: absolute;
  width: 70%;
  height: 70%;
  background-color: black;
  border-radius: 50%;
}
</style>